import dayjs from 'dayjs'

export function convertDate(dateStr: string) {
    const [day, month, year] = dateStr.split('/')
    const jsDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day))
    return dayjs(jsDate).format('D MMM')
}
export const capitalizeFirstLetter = (value: string) => {
    if (value && isNaN(Number(value))) {
        return value[0].toUpperCase() + value.slice(1)
    }
    return value
}
